module.exports = __webpack_public_path__ + "fonts/montserrat-extrabolditalic-webfont.2feba78.woff";